import _Tooltip from "@arco-design/web-react/es/Tooltip";
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useState, useEffect } from 'react';
import { IconSunFill, IconMoonFill } from '@arco-design/web-react/icon';
import postMessage, { postPreviewMessage, POST_MESSAGE_ACTIONS } from '@src/utils/postMessage';
import { useDispatch } from 'react-redux';
import style from './style.less';
import { getItem, setItem, themeModeKey } from '@src/utils/storage';
import useLocale from '@src/hooks/useLocale';
var localTheme = getItem(themeModeKey) || 'light';
export default function ToggleTheme() {
  var dispatch = useDispatch();
  var _a = __read(useState(localTheme === 'dark'), 2),
    dark = _a[0],
    setDark = _a[1];
  var t = useLocale().t;
  useEffect(function () {
    document.body.setAttribute('arco-theme', dark ? 'dark' : 'light');
    postMessage(POST_MESSAGE_ACTIONS.SET_DARK_THEME, dark);
    postPreviewMessage('setDarkTheme', dark);
    setItem(themeModeKey, dark ? 'dark' : 'light');
    dispatch({
      type: 'setThemeMode',
      payload: dark ? 'dark' : 'light'
    });
  }, [dark]);
  return /*#__PURE__*/React.createElement(_Tooltip, {
    content: dark ? t['toggleTheme.theme.toLight'] : t['toggleTheme.theme.toDark']
  }, /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      setDark(!dark);
    },
    className: style['nav-actions-theme'] + " guide-theme-toggle"
  }, dark ? /*#__PURE__*/React.createElement(IconSunFill, null) : /*#__PURE__*/React.createElement(IconMoonFill, null), dark ? t['toggleTheme.theme.light'] : t['toggleTheme.theme.dark']));
}